import { StatusBar } from 'expo-status-bar';
import React from 'react';
import ENV from 'app/utils/ENV'
import { StyleSheet, View, ScrollView, TouchableOpacity, ActivityIndicator } from 'react-native';
import Text from 'app/components/Text'
import apiActions from 'app/utils/apiActions'
import prefActions from 'app/utils/prefActions'
import textHelpers from 'app/utils/textHelpers'
import storageActions from 'app/utils/storageActions'
import { styleSheet, colors, sizes } from 'app/utils/styleSheet'

import Value from 'app/components/Value'
import Timeline from 'app/components/Timeline'
import TimelineGraph from 'app/components/TimelineGraph'
import TimelineEvent from 'app/components/TimelineEvent'
import FilterBar from 'app/components/FilterBar'

import { Ionicons } from '@expo/vector-icons';

export default class TimelineView extends React.Component { 
  constructor(props) {
    super(props);
    let { navigation, route, } = this.props
    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons name="ios-menu" size={32} color={colors.foreground} style={{marginRight: 20}} />
        </TouchableOpacity>
      ),
    })

    this.state = {
      items: [],
      values: [],
      fetching: true,
      prefsLoaded: false,
      // newProgressAt: null,
      // newProgressText: '',
    }
  }

  async componentDidMount(){
    let pref = await prefActions.get()
    await this.setState({hiddenIds: pref.hidden_ids, todoIds: pref.todo_ids, filters: pref.filters, prefsLoaded: true})

    let values = await storageActions.fetchItem('values', [])
    let items = await storageActions.fetchItem('timeline', [])
    // let fetching = !items?.length
    await this.setState({values, items})
    this.fetch()
  }

  componentWillUnmount() {
    if(this._unsubscribe) this._unsubscribe();
  }

  fetch = async () => {
    console.log('calendar fetching...')
    this.setState({fetching: true})
    let timestamp = new Date().toUTCString()
    let timeline = await apiActions.request('values/timeline', 'GET', {timestamp})
    let items = timeline && timeline.events
    if(!!items){
      storageActions.saveItem('timeline', items)
      this.setState({items, fetching: false})
    }
    else
      console.warn('error', items)
  }

  render(){
    let { navigation, route, } = this.props
    let { items, values, fetching, prefsLoaded, } = this.state

    let prevDate = null

    let today = textHelpers.formatDate(new Date().toUTCString())
    let yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)
    yesterday = textHelpers.formatDate(yesterday.toUTCString())

    return (
      <View style={styles.wrapper}>
        {prefsLoaded && (
          <FilterBar
            ref={ref => this.filterBar = ref}
            loading={fetching}
            // filters={filters}
            // hiddenIds={hiddenIds}
            // onUpdate={() => this.setState({filterKey: (this.state.filterKey || 0)+1})}
            onFetch={this.fetch}
            hideQuery={!ENV.WEB}
          />
        )}

        {!!items?.length && (
          <TimelineGraph
            items={items}
            values={values}
          />
        )}

        {!!items?.length && (
          <ScrollView style={styles.section}>
            {items.map((item,i) => {
              let dateHeader = null
              let itemDate = textHelpers.formatDate(item.timestamp)
              let localString = itemDate == today ? 'Today - ' : itemDate == yesterday ? 'Yesterday - ' : ''
              if(itemDate != prevDate){
                dateHeader = (<View style={styles.listHeaderRow} key={`header-${i}`}>
                  <Text style={styles.listHeader}>{localString}{itemDate}</Text>
                </View>)
                prevDate = itemDate
              }
              // let value = values.find(v => v.id == item.value_id)
              return ([
                dateHeader,
                <TimelineEvent
                  key={`timeline-${i}`}
                  event={item} 
                  formatTimestamp={textHelpers.formatTime}
                  value={item.value} 
                  // renderSymbols
                  // style={itemStyle} 
                  // parentId={value.id} 
                  // handleDelete={deleteDoneAt} 
                  // expandNote={true} 
                />
              ])
            })}
            {/*<Timeline value={{timeline: items}} />*/}
          </ScrollView>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    // backgroundColor: '#222',
    flex: 1, 
    alignItems: 'stretch', 
    justifyContent: 'flex-start',
  },
  section: {
    marginTop: 20,
    marginHorizontal: 20,
    alignSelf: 'stretch',
  },
  listHeaderRow: {
    marginTop: sizes.giant,
    marginBottom: sizes.base,
    padding: sizes.large,
    backgroundColor: colors.trim,
  },
  listHeader: {
    fontSize: sizes.large,
    color: colors.foreground,
  },
})